// extracted by mini-css-extract-plugin
module.exports = {"container":"prevendita-chiusa-module--container--1mx5M","content":"prevendita-chiusa-module--content--1ewUX","description":"prevendita-chiusa-module--description--lx8jz"};